import React, { Component } from "react";
import Radio from "@material-ui/core/Radio";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AccessAlarmsIcon from "@material-ui/icons/AccessAlarms";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { createMuiTheme } from "@material-ui/core/styles";
import moment from "moment";
import Popover from "@material-ui/core/Popover";
import { compareTime, timeConvert } from "../../Branches/ContactPageTools";
import { translateMonthArabic } from "../../StoreInfo";
import {
  handleTypeChange,
  setDrawer,
} from "../../../store/actions/deliveryTime";
import { updatePromotions } from "../../../store/actions/cart";

class DeliveryTimeChange extends Component {
  state = { selectOpen: false, displayError: "", anchorEl: null };
  getProduct = (item) => {
    let store_product = this.props.categories.find(
      (category) => category.id === item.category_id
    );

    if (item.parent) {
      store_product = store_product.products
        .find(
          (parent) => parent.id === item.parent && parent.has_variants === true
        )
        .children.find((product) => product.id === item.id);
    } else {
      store_product = store_product.products.find(
        (product) => product.id === item.id
      );
    }
    return store_product;
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleOpen = (e) => {
    const { deliveryTime, language } = this.props;
    let reason = (deliveryTime.scheduled || deliveryTime.pickup)[e.target.value]
      .reason;
    if (reason && (reason.english || reason.arabic)) {
      reason = reason[language];
    } else if (!reason) reason = "";
    this.setState({
      anchorEl: e.currentTarget,
      displayError: reason || "This date is unavailable",
    });
  };

  static defaultProps = {
    highlightColor: "#0099cc",
  };

  renderDate = (str) => {
    const { language } = this.props;
    let temp;

    if (moment(str, "YYYY-MM-DD").year() > moment().year()) {
      temp = moment(str, "YYYY-MM-DD").format("ddd MMM DD Y");
    } else {
      temp = moment(str, "YYYY-MM-DD").format("dddd MMM DD");
    }

    if (moment().format("YYYY-MM-DD") == str) temp = "Today";
    if (language == "english") return temp;

    const ar_months = {
      Jan: "يناير",
      Feb: "فبراير",
      Mar: "مارس",
      Apr: "ابريل",
      May: "مايو",
      Jun: "يونيو",
      Jul: "يوليو",
      Aug: "اغسطس",
      Sep: "سبتمبر",
      Oct: "اكتوبر",
      Nov: "نوفمبر",
      Dec: "ديسمبر",
    };

    const ar_days = {
      Sunday: "الأحد",
      Monday: "الاثنين",
      Tuesday: "الثلاثاء",
      Wednesday: "الاربعاء",
      Thursday: "الخميس",
      Friday: "الجمعة",
      Saturday: "السبت",
      Today: "اليوم",
      Sun: "الأحد",
      Mon: "الاثنين",
      Tue: "الثلاثاء",
      Wed: "الاربعاء",
      Thu: "الخميس",
      Fri: "الجمعة",
      Sat: "السبت",
    };

    Object.keys(ar_months).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_months[key]);
    });
    Object.keys(ar_days).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_days[key]);
    });

    return temp;
  };
  checkIfStoreIsBusy = () => {
    const { language, settings } = this.props;
    if (
      !settings.is_branch_based_ordering ||
      (settings.is_branch_based_ordering && this.props.branch.branch != null)
    ) {
      return !!(
        settings.show_busy_hour_warning &&
        settings.busy_until_active &&
        settings.busy_until_time &&
        settings.busy_until_date &&
        ((compareTime(settings.busy_until_time, moment().format("HH:mm:ss")) ===
          1 &&
          moment(settings.busy_until_date).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")) ||
          moment(settings.busy_until_date).format("YYYY-MM-DD") >
            moment().format("YYYY-MM-DD"))
      );
    } else return false;
  };
  translateMonthArabic = (month) => {
    const ar_months = {
      January: "يناير",
      February: "فبراير",
      March: "مارس",
      April: "ابريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "اغسطس",
      September: "سبتمبر",
      October: "اكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
    };
    return ar_months[month];
  };
  renderStoreIsBusy = () => {
    const { language, settings } = this.props;

    if (this.checkIfStoreIsBusy()) {
      let busyText;
      const englishMessage = `Closed, but you can order for ${moment(
        settings.busy_until_date
      ).format("ll")} at ${timeConvert(settings.busy_until_time, language)}`;
      const arabicMessage = ` نستقبل طلباتكم الآن ليوم ${moment(
        settings.busy_until_date,
        "YYYY-MM-DD"
      ).format("DD")} ${this.translateMonthArabic(
        moment.locale("ar") &&
          moment(settings.busy_until_date, "YYYY-MM-DD").format("MMMM")
      )} - ${timeConvert(settings.busy_until_time, language)}`;
      busyText = language === "english" ? englishMessage : arabicMessage;

      return (
        <div
          className={!settings.show_cover && "product-header-margin"}
          style={{
            backgroundColor: "red",
            height: 34,
            lineHeight: 2.425,
            color: "white",
            fontWeight: "bold",
          }}
        >
          {busyText}
        </div>
      );
    } else {
      return null;
    }
  };

  renderTime = (time) => {
    const { language, settings } = this.props;
    const format = settings.military_delivery_time ? "HH:mm" : "h:mm A";
    const start = time.split(" - ")[0];
    const end = time.split(" - ")[1];
    let temp = `${moment(start, "HH:mm").format(format)} ${
      language === "english" ? "to" : "إلى"
    } ${moment(end, "HH:mm").format(format)}`;
    if (language == "english") return temp;
    return temp.replace(/PM/g, "م").replace(/AM/g, "ص");
  };

  handleAction = () => {
    if (this.props.fromActionButton) {
      this.props.setDrawer(false);
      this.props.handleDialogContinue();
    } else {
      this.props.setDrawer(false);
    }
  };

  render() {
    const { language, deliveryTime } = this.props;
    const customTexts = this.props.settings.custom_texts;
    const theme = createMuiTheme({
      palette: {
        primary: { main: this.props.highlightColor },
      },
    });
    const open = Boolean(this.state.anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
      <>
        {this.props.settings.allow_preordering && this.renderStoreIsBusy()}
        <div>
          <h2
            className={"mx-auto ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{
              width: "90%",
              marginTop: 25,
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              fontSize: 16,
            }}
          >
            {language == "english" ? "Arrival time" : "موعد التسليم"}
          </h2>
          {deliveryTime.asap && (
            <div
              className="row w-100"
              dir={language == "english" ? "ltr" : "rtl"}
              onClick={() => {
                this.props.handleTypeChange("asap");
                this.props.updatePromotions();
              }}
            >
              <div
                className={"align-self-center ".concat(
                  language == "english" ? "col-3" : "col-2"
                )}
              >
                <AccessTimeIcon color="disabled" fontSize={"large"} />
              </div>
              <div
                className={"col-7 align-self-center ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
              >
                <span style={{ fontSize: "1.25rem", display: "block" }}>
                  {language == "english" ? "ASAP" : "في اقرب وقت"}
                </span>{" "}
                {deliveryTime.type == "asap" && (
                  <span>
                    <small
                      style={{
                        color:
                          deliveryTime.expected_date !=
                            moment().format("YYYY-MM-DD") && "red",
                      }}
                    >
                      {this.props.text.replace("On ", "")}
                    </small>
                  </span>
                )}
              </div>

              <div
                className={"align-self-center ".concat(
                  language == "english" ? "col-2" : "col-3"
                )}
              >
                <Radio
                  checked={deliveryTime.type === "asap"}
                  name="radio-button-demo"
                  inputProps={{
                    "aria-label": "A",
                  }}
                  color="primary"
                />
              </div>
            </div>
          )}
          {deliveryTime.scheduled || deliveryTime.pickup ? (
            <div
              className="row w-100 my-3"
              dir={language == "english" ? "ltr" : "rtl"}
              onClick={() => {
                this.props.handleTypeChange("scheduled");
                this.props.updatePromotions();
              }}
            >
              <div
                className={"align-self-center ".concat(
                  language == "english" ? "col-3" : "col-2"
                )}
              >
                <AccessAlarmsIcon color="disabled" fontSize={"large"} />
              </div>
              <div
                className={"col-7 align-self-center ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
              >
                <span style={{ fontSize: "1.25rem" }}>
                  {language == "english"
                    ? `Schedule${
                        !!deliveryTime.pickup ? " pickup " : " "
                      }for later`
                    : `${!!deliveryTime.pickup ? "استلام" : "توصيل"} لاحقا`}
                </span>
              </div>

              <div
                className={"align-self-center ".concat(
                  language == "english" ? "col-2" : "col-3"
                )}
              >
                <Radio
                  checked={deliveryTime.type == "scheduled"}
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "A" }}
                  color="primary"
                />
              </div>
            </div>
          ) : null}
          {(deliveryTime.scheduled || deliveryTime.pickup) &&
            deliveryTime.type == "scheduled" && (
              <div
                className="row w-100 justify-content-between my-5"
                style={{ marginLeft: 0 }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                <div className="col">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={deliveryTime.expected_date}
                    onChange={(e) => {
                      const disabled = !(deliveryTime.scheduled ||
                        deliveryTime.pickup)[e.target.value].active;
                      if (disabled) {
                        this.handleOpen(e);
                      } else {
                        this.props.handleDateChange(e.target.value);
                        this.setState({ selectOpen: false });
                      }
                    }}
                    style={{
                      width: "100%",
                    }}
                    onOpen={() => this.setState({ selectOpen: true })}
                    onClose={(e) => {
                      if (e.target.value === undefined) {
                        this.setState({ selectOpen: false });
                      }
                    }}
                    open={this.state.selectOpen}
                  >
                    {Object.keys(
                      deliveryTime.scheduled || deliveryTime.pickup
                    ).map((slot) => (
                      <MenuItem
                        key={slot}
                        value={slot}
                        style={{
                          direction: language == "english" ? "ltr" : "rtl",
                        }}
                        style={{
                          opacity:
                            !(deliveryTime.scheduled || deliveryTime.pickup)[
                              slot
                            ].active && 0.5,
                          direction: language == "english" ? "ltr" : "rtl",
                        }}
                      >
                        {this.renderDate(slot)}
                      </MenuItem>
                    ))}
                  </Select>

                  <Popover
                    PaperProps={{ style: { padding: 10 } }}
                    id={id}
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <ul
                      className={
                        language == "english"
                          ? "my-3 ml-0 mr-4"
                          : "my-3 mr-0 ml-4"
                      }
                      style={{
                        direction: language == "english" ? "ltr" : "rtl",
                      }}
                    >
                      <li>
                        <p>{this.state.displayError}</p>
                      </li>
                    </ul>
                  </Popover>
                </div>
                <div className="col">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={`${deliveryTime.expected_start} - ${deliveryTime.expected_end}`}
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      this.props.handleTimeChange(e.target.value)
                    }
                    dir={language == "english" ? "ltr" : "rtl"}
                  >
                    {(deliveryTime.scheduled || deliveryTime.pickup)[
                      deliveryTime.expected_date
                    ]["slots"].map((slot) => (
                      <MenuItem
                        key={Math.random() * 10000}
                        value={`${slot["start"]} - ${slot["end"]}`}
                        style={{
                          direction: language == "english" ? "ltr" : "rtl",
                        }}
                      >
                        {this.renderTime(`${slot["start"]} - ${slot["end"]}`)}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            )}
          <Button
            className="ml-1"
            variant="contained"
            color="primary"
            onClick={this.handleAction}
            style={{
              width: "97%",
              marginBottom: 8,
              height: 45,
              fontSize: "1rem",
              marginTop: this.props.applyMarginTopToCloseButton && 15,
              boxShadow: "none",
              textTransform: "none",
            }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {!(
              this.props.fromActionButton &&
              this.props.settings.enable_place_order_directly &&
              this.props.settings.prompt_delivery_time
            )
              ? language === "english"
                ? "Close"
                : "إغلاق"
              : language === "english"
              ? customTexts.time_confirmation_button
              : customTexts.time_confirmation_button_ar}
          </Button>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    deliveryTime: state.deliveryTime,
    categories: state.store.store.categories,
    cart: state.cart,
    branch: state.branch,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleTypeChange: (type) =>
      dispatch({ type: "HANDLE_DELIVERY_TYPE_CHANGE", payload: type }),
    handleDateChange: (date) =>
      dispatch({ type: "HANDLE_DELIVERY_DATE_CHANGE", payload: date }),
    handleTimeChange: (time) =>
      dispatch({ type: "HANDLE_DELIVERY_TIME_CHANGE", payload: time }),
    setDrawer: (state) => dispatch(setDrawer(state)),

    updatePromotions: () => dispatch(updatePromotions()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTimeChange);
